/**
 * **removeAllSpaces**_()_<br>
 * Helper function that returns a string entirely devoid of spaces.
 * @param { String } string: The string to remove spaces from.
 * @returns { String } The input string with spaces removed.
 */
const removeAllSpaces = (str: string): string => str.replace(/\s/g, '');
export default removeAllSpaces;
